import type { Variables, Events } from '../types'

export function useAnalytics() {
  const isInitialized = useState<boolean>('inInitializedAnalytics', () => false)

  async function pushToDataLayer(...args: unknown[]) {
    await until(isInitialized).toBeTruthy()
    if (import.meta.server) {
      console.warn('@st/analytics: Pushing to Data Layer on server')
      return
    }
    // eslint-disable-next-line no-underscore-dangle
    window._mtm.push(...args)
  }

  /**
   * Отправка переменной в Matomo Tag Manager
   * @param variableName - Имя переменной
   * @param value - Значение переменной
   */
  async function sendVariable<K extends keyof Variables>(
    variableName: K,
    value: Variables[K],
  ) {
    pushToDataLayer({
      [variableName]: value,
    })
    pushToDataLayer({ event: 'sendVariable' })
  }

  /**
   * Отправка события в Matomo Tag Manager
   * @param eventName - Имя события из интерфейса Events
   * @param payload - Данные события
   */
  async function sendEvent<K extends keyof Events>(
    eventName: K,
    payload?: Events[K],
  ) {
    pushToDataLayer({
      event: eventName,
      ...(payload ?? {}),
    })
  }

  return { sendEvent, sendVariable }
}
